import { IAction, ActionType } from "../../classes/actiontype";
import { AppState } from "../../classes/app-state";
import { Dispatch } from "redux";
import { favoritePage, unfavoritePage } from "./index";
import { FavoriteApiResult } from "../../classes/favorites-api";
import axios, { AxiosResponse } from 'axios';
import { invertLocalFavorite } from "./app-state";

export function requestFavorite(): IAction {
    return {
        type: ActionType.REQUEST_FAVORITE
    }
}

export function receivedFavoriteData(data: string): IAction {
    return {
        type: ActionType.RECEIVE_FAVORITE,
        value: data
    }
}

export function receivedFavoriteError(error: string): IAction {
    return {
        type: ActionType.ERROR_FAVORITE,
        value: error
    }
}



export function toggleFavorite() {
    return (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const state = getState();

        if (state.favoritesState.isFavorite) {
            dispatch(unfavoritePage());
        } else {
            dispatch(favoritePage());
        }

        axios.post(`/Umbraco/Api/FavoritesApi/ToggleFavorites?key=${state.favoritesState.pageKey}`, null, {
            withCredentials: true
        }).then((json: AxiosResponse<FavoriteApiResult>) => {
            switch (json.data) {
                case FavoriteApiResult.ADDED: {
                    dispatch(favoritePage());
                    dispatch(receivedFavoriteData("success"));
                    break;
                }

                case FavoriteApiResult.REMOVED: {
                    dispatch(unfavoritePage());
                    dispatch(receivedFavoriteData("success"));
                    break;
                }

                case FavoriteApiResult.ERROR: {
                    dispatch(invertLocalFavorite());
                    dispatch(receivedFavoriteError("Error"));
                    break;
                }
                default:
                    break;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/redux/actions/api-state.ts